import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  InitialStateType,
  SetCuratedProductCriteriaModalFormPayloadType,
  SetCuratedProductCriteriaPayloadType,
  SetSubCategoryFormPayloadType,
  SubCategoryFormType,
  SubCategoryType,
  DialogType,
  VendorFormType,
} from 'features/CategoryAndPosisi/@types/CatalogueAddEdit'
import { AutoCurationDialogStateType } from 'features/CategoryAndPosisi/@types/CuratedProductCriteria'

export const SLICE_NAME_CATALOGUE_ADD_EDIT = 'catalogueAddEdit'

const initialState: InitialStateType = {
  autoCurationDialogState: 'CLOSE',
  isProductCriteriaActive: false,
  productCriteriaInclude: {},
  productCriteriaExclude: {},
  /** use to be mapping on the modal form */
  productCriteriaIncludeModalForm: {},
  productCriteriaExcludeModalForm: {},
  /** end */
  subCategories: [],
  subCategoryForm: {
    productCriteriaExclude: {},
    productCriteriaInclude: {},
  },
  selectedSubCategoryToEdit: null,
  dialog: {
    mode: '',
    dndData: [],
  },
  banner: { list: [] },
  catalogueDetail: {},
  vendorForm: { vendor: [], brand: [] },
  isEditPopupAddEdit: false,
  isShowPopupAddEdit: false,
}

const slice = createSlice({
  name: SLICE_NAME_CATALOGUE_ADD_EDIT,
  initialState,
  reducers: {
    resetState: () => initialState,
    resetCatalogueDetail: (state) => {
      state.catalogueDetail = initialState.catalogueDetail
    },
    setAutoCurationDialogState: (
      state,
      { payload }: PayloadAction<AutoCurationDialogStateType>,
    ) => {
      state.autoCurationDialogState = payload
    },

    setCuratedProductCriteria: (
      state,
      { payload }: PayloadAction<SetCuratedProductCriteriaPayloadType>,
    ) => {
      state[payload.field] = payload.value
    },

    toggleProductCriteriaActive: (state, { payload }: PayloadAction<boolean>) => {
      state.isProductCriteriaActive = payload
    },

    resetCuratedProductCriteria: (state) => {
      state.isProductCriteriaActive = initialState.isProductCriteriaActive
      state.productCriteriaInclude = initialState.productCriteriaInclude
      state.productCriteriaExclude = initialState.productCriteriaExclude
    },

    setCuratedProductCriteriaModalForm: (
      state,
      { payload }: PayloadAction<SetCuratedProductCriteriaModalFormPayloadType>,
    ) => {
      state[payload.field] = payload.value
    },

    setSubCategories: (state, { payload }: PayloadAction<SubCategoryType[]>) => {
      state.subCategories = [...payload]
    },

    setSubCategoryForm: (state, { payload }: PayloadAction<SetSubCategoryFormPayloadType>) => {
      state.subCategoryForm[payload.field] = payload.value
    },

    resetSubCategoryForm: (state, { payload }: PayloadAction<SubCategoryFormType | undefined>) => {
      state.subCategoryForm =
        typeof payload === 'undefined' ? { ...initialState.subCategoryForm } : { ...payload }
    },

    setSelectedSubCategoryToEdit: (
      state,
      { payload }: PayloadAction<Nullable<SubCategoryType>>,
    ) => {
      state.selectedSubCategoryToEdit = payload
    },
    setDialog: (state, { payload }: PayloadAction<Partial<DialogType>>) => {
      state.dialog = { ...state.dialog, ...payload }
    },
    setBanner: (state, { payload }: PayloadAction<Partial<InitialStateType['banner']>>) => {
      state.banner = { ...state.banner, ...payload }
    },
    setCatalogueDetail: (
      state,
      { payload }: PayloadAction<Partial<InitialStateType['catalogueDetail']>>,
    ) => {
      state.catalogueDetail = payload
    },
    setVendorForm: (state, { payload }: PayloadAction<Partial<VendorFormType>>) => {
      state.vendorForm = { ...state.vendorForm, ...payload }
    },
    setIsShowPopupAddEdit: (state, { payload }: PayloadAction<boolean>) => {
      state.isShowPopupAddEdit = payload
    },
    setIsEditPopupAddEdit: (state, { payload }: PayloadAction<boolean>) => {
      state.isEditPopupAddEdit = payload
    },
  },
})

export const {
  resetState,
  setAutoCurationDialogState,
  toggleProductCriteriaActive,
  setCuratedProductCriteria,
  resetCuratedProductCriteria,
  setCuratedProductCriteriaModalForm,
  setSubCategories,
  setSubCategoryForm,
  setSelectedSubCategoryToEdit,
  resetSubCategoryForm,
  setDialog,
  setBanner,
  setCatalogueDetail,
  resetCatalogueDetail,
  setIsShowPopupAddEdit,
  setIsEditPopupAddEdit,
  setVendorForm,
} = slice.actions
export default slice.reducer
